"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M15 8C15.552 8 16 8.447 16 9V17C16 17.553 15.552 18 15 18H5C4.448 18 4 17.553 4 17V9C4 8.447 4.448 8 5 8H7.5C7.776 8 8 8.224 8 8.5V13C8 14.214 9.087 15.179 10.338 14.972C11.321 14.81 12 13.884 12 12.888V8.5C12 8.224 12.224 8 12.5 8H15ZM8.99995 13V5.5C8.99995 5.294 8.76495 5.176 8.59995 5.3L7.59995 5.8C7.15795 6.131 6.53095 6.042 6.19995 5.6C5.86895 5.157 5.95795 4.531 6.39995 4.2L9.39995 2.2C9.41695 2.188 9.43595 2.187 9.45195 2.176C9.48595 2.152 9.51995 2.133 9.55695 2.115C9.59895 2.094 9.64195 2.078 9.68795 2.062C9.72895 2.049 9.76895 2.035 9.81095 2.026C9.85195 2.019 9.89095 2.017 9.93295 2.014C9.95595 2.012 9.97595 2 9.99995 2C10.024 2 10.044 2.012 10.067 2.014C10.109 2.017 10.148 2.019 10.189 2.026C10.231 2.035 10.271 2.049 10.312 2.062C10.357 2.078 10.401 2.094 10.443 2.115C10.48 2.133 10.514 2.152 10.548 2.176C10.564 2.187 10.583 2.188 10.6 2.2L13.6 4.2C13.862 4.396 14 4.697 14 5.001C14 5.209 13.935 5.42 13.8 5.6C13.469 6.042 12.842 6.131 12.4 5.8L11.4 5.3C11.235 5.176 11 5.294 11 5.5V13C11 13.552 10.553 14 9.99995 14C9.44695 14 8.99995 13.552 8.99995 13Z",
    fill: "#727B7F"
  }));
};